import { useState } from 'react';

/**
 * Owns the record-test modal's selection state for the mobile session.
 *
 * `selectedAsset` and `modalInitialValues` are only ever set together, in one of
 * three combinations (open for edit, open pre-filled as a fail, close), so they
 * live here rather than as loose state in MobileSessionView.
 *
 * The fail-prefill needs the session's test context to name the test type. It is
 * passed in rather than read here, so this hook stays about modal state only.
 *
 * @param {object} params
 * @param {boolean} params.isExitEmergency
 * @param {string} params.sessionTestType
 */
export function useRecordModal({ isExitEmergency, sessionTestType }) {
  const [selectedAsset, setSelectedAsset] = useState(null);
  const [modalInitialValues, setModalInitialValues] = useState(null);

  const openEditModal = (asset, sessionEntry = null) => {
    setModalInitialValues(
      sessionEntry != null && (sessionEntry.status || sessionEntry.testId != null)
        ? { result: sessionEntry.status ?? undefined }
        : null
    );
    setSelectedAsset(asset);
  };

  const openFailEditModal = (asset, overrides = {}) => {
    const testType = overrides.testType ?? (isExitEmergency ? '90-minute Discharge' : sessionTestType);
    setModalInitialValues({
      result: 'fail',
      testType,
      defectsFound: overrides.defectsFound ?? '',
    });
    setSelectedAsset(asset);
  };

  const handleRecordModalClose = () => {
    setSelectedAsset(null);
    setModalInitialValues(null);
  };

  return {
    selectedAsset,
    modalInitialValues,
    openEditModal,
    openFailEditModal,
    handleRecordModalClose,
  };
}
